import { providers } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { serviceProviderUiDefaults } from '../util';

export default providers.syndigo.extend({
  ...serviceProviderUiDefaults,
  hasIntrospectableSchema: Boolean(providers.syndigo.introspectionType),
  defaultAuthenticationType: 'custom',
  avatarPath: avatars.syndigo,
  logoPath: logos.syndigo
});
